var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitterInfoNum02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5229 20 20 15.5228 20 10C20 4.47715 15.5229 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#9F6BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91004 12.89L10 10.17C10.72 9.50998 11.13 9.07998 11.14 8.43998C11.14 7.72998 10.61 7.29998 9.90004 7.28998C9.17004 7.28998 8.69004 7.74998 8.69004 8.51998H6.79004C6.79004 6.80998 8.04004 5.72998 9.91004 5.72998C11.78 5.72998 13.07 6.76998 13.07 8.27998C13.07 9.24998 12.58 10.07 10.75 11.67L9.68004 12.65V12.71H13.17V14.33H6.90004V12.89H6.91004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitterInfoNum02);
export default __webpack_public_path__ + "static/media/sitter_info_num_02.bea6b1dc25b05d9a59540a59a76401a4.svg";
export { ForwardRef as ReactComponent };